import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Atelier — Alex Morgan',
    description:
        'The portfolio of Alex Morgan, an independent product and brand designer, presented as an interactive macOS desktop you can explore.',
    url: 'https://modulify.com',
    ogImage: '/atelier/Wallpaper%20v2.jpg'
}
